import {GameInfoModuleFetchHandler} from "./game-info-module.fetch-handler";
import {HandlerList} from "../../../../../infrastructure/handlers/handler-list";
import {TimingHandler} from "../../../../../infrastructure/handlers/timing-handler";
import {FullGamePopulateDataHandler} from "../../../../../core/handlers/full-game.populate-data.handler";

export class GameInfoModuleHandlers extends HandlerList {
  static injectables = [
    GameInfoModuleFetchHandler,
    TimingHandler,
    FullGamePopulateDataHandler
  ];

  constructor(
    gameInfoModuleFetchHandler: GameInfoModuleFetchHandler,
    timingHandler: TimingHandler,
    fullGamePopulateDataHandler: FullGamePopulateDataHandler
  ) {
    super();

    [
      gameInfoModuleFetchHandler,
      timingHandler,
      fullGamePopulateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
